import { render, staticRenderFns } from "./AxCardFieldIcon.vue?vue&type=template&id=d63c344c&scoped=true"
import script from "./AxCardFieldIcon.vue?vue&type=script&lang=ts"
export * from "./AxCardFieldIcon.vue?vue&type=script&lang=ts"
import style0 from "./AxCardFieldIcon.vue?vue&type=style&index=0&id=d63c344c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63c344c",
  null
  
)

export default component.exports